/**
 * @desc 基座应用骨架页
 * @time 2023-07-31 15:48:06
 * @user simxin
 */

import { LayoutSider, LayoutContent } from '@src/component/layout/full';
import { LayoutMenu } from '@src/component/layout/menu';
import { LayoutLand } from '@src/component/layout/land';
import { ErrorStatus, LoadingStatus } from '@src/component/loading';
import { usePortalStore } from '@src/store';
import { useBanned } from '@src/hooks/useBanned';
import { Banned } from '@src/component/banned/banned';
import { useState, useEffect } from 'react';

export const Products = () => {
  const errorPortal = usePortalStore(state => state.errorPortal);
  const { loading, isBanned } = useBanned();
  const [showMenu, setShowMenu] = useState(false);
  const [disabledPaths, setDisabledPaths] = useState<string[]>([]);

  useEffect(() => {
    const handleShowMenu = (e: Event) => {
      const detail = (e as CustomEvent)?.detail;
      const visible = detail?.visible !== false;
      const nextDisabledPaths = detail?.data?.disabledPaths;

      setShowMenu(visible);
      setDisabledPaths(Array.isArray(nextDisabledPaths) ? nextDisabledPaths : []);
    };
    const handleHideMenu = () => {
      setShowMenu(false);
      setDisabledPaths([]);
    };

    document.body?.addEventListener('showMenu', handleShowMenu);
    document.body?.addEventListener('hideMenu', handleHideMenu);

    // 子应用可能早于宿主发布状态，监听器就绪后主动请求一次快照。
    document.body?.dispatchEvent(new CustomEvent('deskbuddyShellReady'));

    return () => {
      document.body?.removeEventListener('showMenu', handleShowMenu);
      document.body?.removeEventListener('hideMenu', handleHideMenu);
    };
  }, []);

  if (errorPortal) return <ErrorStatus />;
  if (loading) return <LoadingStatus />;
  if (isBanned) return <Banned />;

  return (
    <>
      {showMenu && (
        <LayoutSider>
          <LayoutMenu disabledPaths={disabledPaths} />
        </LayoutSider>
      )}
      <LayoutContent>
        <LayoutLand />
      </LayoutContent>
    </>
  );
};
